module.exports = __webpack_public_path__ + "img/minty.d4f339d1.png";